<template>
    <!-- :disabled="readonly || config.readonly" -->
    <div class="x-rich-text">
        <QuillEditor ref="myQuillEditor" theme="snow" v-model:content="content" :options="editorOption" contentType="html"
            @editorChange="editorChange" @update:content="(value) => $emit('update:modelValue', value)" />
    </div>
    <!-- :model-value="modelValue" @update:modelValue="(value, oldvalue)=>$emit('update:modelValue', value, oldvalue)"
            > -->
</template>
<script setup>
import { getOptions, mergeFilter,} from '../utils.js';
import { ref,watch } from 'vue'
import axios from 'axios'
import { QuillEditor, Quill } from "@vueup/vue-quill";
import ImageUploader from "quill-image-uploader";
// import { ImageDrop } from "quill-image-drop-module";
import BlotFormatter from 'quill-blot-formatter/dist/BlotFormatter'
import { useTokenStore } from '../../store/TokenStore';
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import 'quill-image-uploader/dist/quill.imageUploader.min.css';

Quill.register("modules/imageUploader", ImageUploader);
// Quill.register("modules/imageDrop", ImageDrop);
let  d =null
if(BlotFormatter.default){
    d=  BlotFormatter.default
}else{
    d= BlotFormatter
}
Quill.register("modules/blotFormatter", d);
const tokenStore = useTokenStore()
const myQuillEditor = ref();
const content = ref('')
const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null }
})
const editorOption = {
    modules: {
        toolbar: {
            container: [
                ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
                ["blockquote", "code-block"], //引用，代码块
                [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
                [{ list: "ordered" }, { list: "bullet" }], //列表
                [{ script: "sub" }, { script: "super" }], // 上下标
                [{ indent: "-1" }, { indent: "+1" }], // 缩进
                [{ direction: "rtl" }], // 文本方向
                [{ size: ["small", false, "large", "huge"] }], // 字体大小
                [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
                [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
                [{ font: [] }], //字体
                [{ align: [] }]["clean"], //对齐方式 //清除字体样式
                ["image", "video"] //上传图片、上传视频
            ],
            handlers: {
                // video: function (value) {
                //     if (value) {
                //         //调用图片上传
                //         // proxy.$refs.uploadRef.click();
                //         // 劫持原来的视频点击按钮事件
                //         document.querySelector("#uploadFileVideo")?.click();
                //     } else {
                //         Quill.format("video", true);
                //     }
                // },
            }
        },
        // imageDrop: true,
        blotFormatter: {
            toolbar: {
                mainClassName: "blot-formatter__toolbar"
            }
        },
        // videoResize: {},
        imageUploader: {
            upload: (file) => {
                return new Promise((resolve, reject) => {
                    const formData = new FormData();
                    formData.append("file", file);
                    console.log(file);
                    // setTimeout(() => {
                    //     resolve(
                    //         "https://img0.baidu.com/it/u=4230588695,3357195812&fm=253&fmt=auto&app=120&f=JPEG?w=953&h=800"
                    //     );
                    // }, 100);
                    axios({
                        method: "post",
                        url: "/dev-api/system/sysAttachment/upload/sysAttachment",
                        data: formData,
                        headers: {
                            Authorization: "Bearer " + tokenStore.token
                        },
                        // responseType: "blob" //非常重要不可少
                    }).then((res) => {
                          console.log(res)
                          resolve('/public-files'+res.data.data.fileUrl+res.data.data.memo)
                        // if (index == 1) {
                        //     user.value.idcardFace = res.data.data.resourceUri;
                        // } else if (index == 2) {
                        //     user.value.idcardEmblem = res.data.data.resourceUri;
                        // } else if (index == 3) {
                        //     user.value.idcardEmblem = res.data.data.resourceUri;
                        // } else if (index == 4) {
                        //     user.value.professionalQualification = res.data.data.resourceUri;
                        // }
                    });
                    //   axios.post('/upload-image', formData)
                    //   .then(res => {
                    //     console.log(res)
                    //     resolve(res.data.url);
                    //   })
                    //   .catch(err => {
                    //     reject("Upload failed");
                    //     console.error("Error:", err)
                    //   })
                });
            }
        }
    },
    placeholder: "请输入内容..."
};
watch(()=>props.modelValue, (value)=> {
    content.value = props.modelValue
}, {immediate:true})
content.value = props.modelValue
const editorChange = (e) => {
}
</script>